import React from 'react';
import { useEffect } from 'react';
import { useGroupState, useGroupActions } from './GroupContext';
import GroupMembersLoader from './GroupMembersLoader';
import MembersList from './MembersList';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';

import styles from './GroupMembers.module.scss';

const GroupMembersContent = () => {
  const state = useGroupState();

  if (state?.loading) {
    return (
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading</p>
        </Stack>
      </div>
    );
  }

  const groupPath = state?.group?.path || (state?.group?.id ? `/groups/${state.group.id}` : null);

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        {groupPath && (
          <a href={groupPath} style={{ fontSize: '20px', color: '#007753', textDecoration: 'none' }}>
            &lt; Back to Group
          </a>
        )}
        <PageTitle text={'Group Members'} />
        <MembersList />
      </Stack>
    </div>
  );
};

const GroupMembers = ({ id }) => {
  const { initializeState } = useGroupActions();

  useEffect(() => {
    initializeState(id);
  }, []);

  return (
    <>
      <GroupMembersLoader />
      <GroupMembersContent />
    </>
  );
};

export default GroupMembers;
